var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualTaxSettlementRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 140.2,
    y1: 42.1,
    x2: 152.9,
    y2: 42.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 140.6,
    y1: 50.7,
    y2: 50.7,
    xlinkHref: "#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 145.3,
    y1: 33.8,
    x2: 147.8,
    y2: 33.8,
    xlinkHref: "#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 145.3,
    y1: 55.1,
    x2: 147.8,
    y2: 55.1,
    xlinkHref: "#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 46.2,
    y1: 73.6,
    x2: 119.6,
    y2: 73.6,
    xlinkHref: "#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98",
    x1: 58.5,
    y1: 65.1,
    x2: 106.8,
    y2: 65.1,
    xlinkHref: "#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M151.2 40.6s-.8-4.8-4.8-4.8c-3.9 0-5 4.8-5 4.8l10.2 7.7",
    stroke: "url(#SVGID_0_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1 MI_4L_gradient",
    d: "M141.9 48.3s.8 4.8 4.8 4.8c3.9 0 5-4.8 5-4.8",
    stroke: "url(#SVGID_1_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0 MI_4L_gradient",
    stroke: "url(#SVGID_2_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)",
    d: "M146.5 31.8v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4 MI_4L_gradient",
    stroke: "url(#SVGID_3_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)",
    d: "M146.5 53.1v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.5 101.2c-3.1 6-9.4 10.1-16.7 10.1s-13.7-4.2-16.8-10.4M105.6 70.6c0 .8.1 1.6.1 2.4 0 12.9-10.4 23.3-23.3 23.3S59.1 85.9 59.1 73s.1-2.1.3-3.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3 MI_4L_gradient",
    d: "M59.4 103.5c-7-2.1-12-7.7-12-7.7s2.5-1.4 4.6-6c2.1-4.6.8-16.9.8-16.9 0-16.5 13.3-29.8 29.8-29.8s29.8 13.3 29.8 29.8c0 0-.7 12.7 2.5 18.2 1.4 2.8 3.5 4.7 3.5 4.7s-4.9 5-12 8.2",
    stroke: "url(#SVGID_4_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2 MI_4L_gradient",
    d: "M59.8 69.9s5.5.4 13.9-1.8c8.4-2.1 16.7-8.3 16.7-8.3s5.5 9.3 15.2 10.7",
    stroke: "url(#SVGID_5_0befaf6cb1a5459d77e1b391c49e053676c3db8f8ff37fd2b13945bf38ed0d98)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M42.4 132.7c1.9-20.4 19.1-36.4 40.1-36.4s38 15.8 40 36.1M146.5 21.7c-12.8 0-23.1 10.4-23.1 23.1s2 10.7 5.2 14.7 2.3 6.2-6.3 9.6c0 0 8 4.2 15.7-2.7 2.6 1 5.5 1.6 8.5 1.6 12.8 0 23.1-10.4 23.1-23.1s-10.4-23.1-23.1-23.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualTaxSettlementRequests);
export default __webpack_public_path__ + "static/media/annualTaxSettlementRequests.5f3be972f3d3f6f129b53bd4345c321c.svg";
export { ForwardRef as ReactComponent };